/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {
  SchemaField,
  Document,
  PicklistFormat,
  DocumentSchema,
  SystemFieldType,
  PicklistValue
} from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { PicklistService } from '../../../services/picklist/picklist.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-picklist-field',
    templateUrl: './picklist-field.component.html',
    styleUrls: ['./picklist-field.component.scss'],
    standalone: false
})
export class PicklistFieldComponent implements DynamicField, OnDestroy {
  PicklistFormat = PicklistFormat;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  showFieldAsEdit: boolean = false;
  selectedValue: string = '---';
  picklistValues: any[] = [];
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  ngOnInit(): void {
    if (!!this.picklistValues && this.picklistValues.length == 0 && !!this.field) {
      if (!!this.field.picklistDatasetUId) {
        this.picklistService
          .getPicklistValues(this.field)
          .pipe(take(1))
          .subscribe(picklistValues => {
            this.picklistValues = picklistValues?.filter(p => p.isActive === true);
            this.changeDetector.markForCheck();

            if (!!this._value) {
              this.selectedValue = this.picklistValues.find(p => p.uId === this._value)?.value || '---';
            }
          });
      } else {
        this.picklistValues = this.field?.picklistValues?.filter(p => p.isActive === true);
        if (!!this._value) {
          this.selectedValue = this.picklistValues.find(p => p.uId === this._value)?.value || '---';
        }
      }
    }
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  get value(): any {
    if (!this._value) {
      return null;
    }

    return this._value;
  }

  set value(val: any) {
    this._value = val;

    if (!!this.picklistValues) {
      this.selectedValue = this.picklistValues.find(p => p.uId === this._value)?.value || '---';
    }
  }
  _value: any;

  constructor(private picklistService: PicklistService, private changeDetector: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
    }
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  checkChange(elm: any): void {
    if (elm.srcElement.checked) {
      this.value = elm.srcElement.value;
    } else {
      this.value = null;
    }

    this.onValueChanged();
  }
}
